import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Routes, Route} from "react-router-dom";
import axios from "./services/axios";
import './config/yup';
import PrivateRoute from "./components/base/PrivateRoute";
import {getUserProfile} from "./redux/reducer/authSlice";
const Login = React.lazy(() => import('./pages/Login'));
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const Pages = React.lazy(() => import('./pages/Pages'));
const Page = React.lazy(() => import('./pages/Page'));
const Users = React.lazy(() => import( "./pages/Users"));
const User = React.lazy(() => import( "./pages/User"));
const Files = React.lazy(() => import( "./pages/Files"));
const Categories = React.lazy(() => import( "./pages/Categories"));
const Category = React.lazy(() => import( "./pages/Category"));
const Brands = React.lazy(() => import( "./pages/Brands"));
const BrandCreate = React.lazy(() => import( "./pages/BrandCreate"));
const BrandEdit = React.lazy(() => import( "./pages/BrandEdit"));
const Orders = React.lazy(() => import( "./pages/Orders"));
const Order = React.lazy(() => import( "./pages/Order"));
const Products = React.lazy(() => import( "./pages/Products"));
const Product = React.lazy(() => import( "./pages/Product"));
const Addresses = React.lazy(() => import( "./pages/Addresses"));
const Configs = React.lazy(() => import( "./pages/Configs"));
const Config = React.lazy(() => import( "./pages/Config"));

function App() {

    const isLogin = useSelector(state => state.auth.isLogin);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isLogin) {
            axios.get('/auth/user')
                .then(response => {
                    dispatch(getUserProfile(response.data));
                })
        }
    }, [dispatch, isLogin])

    return (
        <Routes>
            <Route path="/login" element={<Login/>} />
            <Route path="" element={<PrivateRoute/>}>
                <Route path="/" element={<Dashboard/>} />
                <Route path="/pages" element={<Pages/>} />
                <Route path="/pages/:id/update" element={<Page/>} />
                <Route path="/users" element={<Users/>} />
                <Route path="/users/create" element={<User/>} />
                <Route path="/users/:id/update" element={<User/>} />
                <Route path="/files" element={<Files/>} />
                <Route path="/categories" element={<Categories/>} />
                <Route path="/categories/create" element={<Category/>} />
                <Route path="/categories/:id/update" element={<Category/>} />
                <Route path="/brands" element={<Brands/>} />
                <Route path="/brands/create" element={<BrandCreate/>} />
                <Route path="/brands/:id/update" element={<BrandEdit/>} />
                <Route path="/orders" element={<Orders/>} />
                <Route path="/orders/:id" element={<Order/>} />
                <Route path="/products" element={<Products/>} />
                <Route path="/products/:id/update" element={<Product/>} />
                <Route path="/addresses" element={<Addresses/>} />
                <Route path="/configs" element={<Configs/>} />
                <Route path="/configs/create" element={<Config/>} />
                <Route path="/configs/:id/update" element={<Config/>} />
            </Route>
        </Routes>
    );
}

export default App;
